import React from 'react'
import Layout from './layout'
import { graphql } from 'gatsby'
import ScrollContainer from './scroll-container'
import ZoomImage from './zoom-image'
import styled, { css } from 'react-emotion'

const Description = styled.div`
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	min-height: 100px;
	text-align: left;
	padding-left: 10px;
	font-style: normal;
	font-weight: normal;
`

const scrollStyles = css`
	position: fixed;
	left: 0;
	padding-top: 100px;
	width: 100%;
	height: 100%;
`

let itemStyle = () => {}

if (typeof window !== 'undefined')
	itemStyle = item => ({
		flexBasis:
			window.innerHeight /
				window.innerWidth *
				70 *
				item.props.fluid.aspectRatio +
			'vw'
	})

export default function Collection({
	data: {
		prismicCollection: { data }
	}
}) {
	return (
		<Layout>
			<Description
				dangerouslySetInnerHTML={{
					__html: data.body.html
				}}
			/>
			<ScrollContainer className={scrollStyles} itemStyle={itemStyle}>
				{data.body1 &&
					data.body1[0].items.map(item => (
						<ZoomImage
							key={item.image.url}
							fluid={item.image.localFile.childImageSharp.fluid}
							original={item.image.localFile.publicURL}
							content={item.description.html}
						/>
					))}
			</ScrollContainer>
		</Layout>
	)
}

export const query = graphql`
	query collectionData($id: String!) {
		prismicCollection(id: { eq: $id }) {
			data {
				title {
					text
				}
				body {
					html
				}
				body1 {
					items {
						image {
							url
							localFile {
								childImageSharp {
									fluid(maxWidth: 1000) {
										...GatsbyImageSharpFluid
									}
								}
								publicURL
							}
						}
						description {
							html
						}
					}
				}
			}
		}
	}
`
